import { createApp } from 'vue'
import App from './App.vue'
import router from '../../router/staff'
import store from '../../store'
import setupInterceptors from '../../services/setupInterceptors'
import Notifications from '@kyvg/vue3-notification'
import vClickOutside from 'click-outside-vue3'
import TOAST from 'vue-toastification'
import 'vue-toastification/dist/index.css'

setupInterceptors(store)

createApp(App)
  .use(store)
  .use(Notifications)
  .use(router)
  .use(vClickOutside)
  .use(TOAST, {
    draggable: false,
    hideProgressBar: true,
    icon: false,
    closeButton: false,
    toastClassName: 'custom-toast',
  })
  .mount('#app')
